export const TRUSTED_BY_IMAGES_URLS = [
  { id: 0, url: '/images/icons-swiper/mayfair.webp', height: '64px', width: '92px' },
  { id: 1, url: '/images/icons-swiper/finch.webp', height: '32px', width: '116px' },
  { id: 2, url: '/images/icons-swiper/softorino.webp', height: '46px', width: '58px' },
  { id: 3, url: '/images/icons-swiper/cocoatech.webp', height: '23px', width: '145px' },
  { id: 4, url: '/images/icons-swiper/ocus.webp', height: '23px', width: '81px' },
  { id: 5, url: '/images/icons-swiper/shelterluv.webp', height: '16', width: '161px' },
  { id: 6, url: '/images/icons-swiper/sup.webp', height: '41px', width: '90px' },
  { id: 7, url: '/images/icons-swiper/project-fitter.webp', height: '27px', width: '163px' },
  { id: 8, url: '/images/icons-swiper/hour-timesheet.webp', height: '34px', width: '188px' },
  { id: 9, url: '/images/icons-swiper/label-your-data.webp', height: '42px', width: '81px' },
  { id: 10, url: '/images/icons-swiper/remedico-new.webp', height: '22px', width: '118px' },
  { id: 11, url: '/images/icons-swiper/ecaterin.webp', height: '22px', width: '158px' },
  { id: 12, url: '/images/icons-swiper/outstaff-your-team.webp', height: '41px', width: '91px' },
  { id: 13, url: '/images/icons-swiper/astime.webp', height: '40px', width: '120px' },
  { id: 14, url: '/images/icons-swiper/stayloyal.webp', height: '46px', width: '75px' },
  { id: 15, url: '/images/icons-swiper/minute.webp', height: '33px', width: '120px' },
];
